function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M2 4a2 2 0 110-4 2 2 0 010 4zm6 0a2 2 0 110-4 2 2 0 010 4zm6 0a2 2 0 110-4 2 2 0 010 4z",
  fill: "#FFF",
  fillRule: "evenodd"
});

var SvgMoreIcon = function SvgMoreIcon(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 4,
    viewBox: "0 0 16 4"
  }, props), _ref);
};

export default SvgMoreIcon;